<template>
  <div
    class="user-profile"
    :class="{
      'bg-zinc-100 text-black': isActive,
      'bg-[#058242] text-white': !isActive,
    }"
  >
    <div class="user-profile__content">
      <svg-icon name="user" class="user-profile__icon" />
      <span class="user-profile__name">
        {{ displayName }}
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default defineComponent({
  components: { SvgIcon },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isActive() {
      return !!this.user?.id;
    },
    displayName() {
      if (!this.user) return this.$t("profile.personalCabinet");
      return this.user.first_name + " " + this.user.last_name;
    },
  },
});
</script>

<style scoped lang="scss">
.user-profile {
  @apply p-[12px] rounded-2xl flex items-center cursor-pointer;

  &__content {
    @apply flex items-center gap-2;
  }

  &__icon {
    @apply w-6 h-6;
  }

  &__name {
    @apply hidden sm:block text-[16px] leading-[21px];
  }
}
</style>
